export default {
  title: 'Facturas de terceros por gastos suplidos',
  addSelected: 'Añadir seleccionado'
}
